import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { StorageService } from '../services/storage.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      // Handle 401 Unauthorized errors globally
      if (error.status === 401) {
        storage.removeItem('access_token');
        storage.removeItem('role');
        storage.removeItem('user');
        storage.removeItem('active_tenant');
        storage.removeItem('temp_token');

        router.navigate(['/auth/login'], {
          queryParams: { sessionExpired: 'true' }
        });
      }
      return throwError(() => error);
    })
  );
};
